import { ChevronDown } from "lucide-react";
import { useState } from "react";
import styles from "../styles/PaymentInfo.module.css";

export default function PaymentInfo() {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.container}>
        <h2 className={styles.title}>💳 Как работает оплата и списания</h2>
      {/* Кнопка */}
      <button onClick={() => setOpen((prev) => !prev)} className={styles.button}>
        <h2 className={styles.title}>💳 подробнее</h2>
        <ChevronDown
          className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}
        />
      </button>

      {/* Контент */}
      {open && (
        <div className={styles.content}>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              🔹 При подключении тарифа или сервиса вы{" "}
              <b>оплачиваете их стоимость за 30 дней</b>.
            </li>
            <li className={styles.listItem}>
              🔹 Услуги <b>сразу активируются</b>, а оплаченная сумма{" "}
              <b>ежедневно списывается равными долями</b>.
            </li>
            <li className={styles.listItem}>
              🔹 При подключении нового сервиса позже нужно{" "}
              <b>оплатить его стоимость за 30 дней</b>, и он добавится в
              ежедневное списание.
            </li>
            <li className={styles.listItem}>
              🔹 <b>При отключении сервиса его списания прекращаются сразу</b>,
              ежедневные расходы уменьшаются, а сервис становится неактивным.
            </li>
            <li className={`${styles.listItem} ${styles.warning}`}>
              ❗ Дополнительные сервисы работают только при активном тарифе.
            </li>
          </ul>

          {/* Блок с поддержкой */}
          <p className={styles.support}>
            По всем возникающим вопросам обращайтесь в{" "}
            <a
              href="https://t.me/Kirilmalukov"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.supportLink}
            >
              Техподдержку
            </a>
          </p>
        </div>
      )}
    </div>
  );
}
